import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import CheckIcon from '../../images/icons/check.svg';
import DropdownIcon from '../../images/icons/dropdown-arrow.svg'
import { Image } from 'react-bootstrap';

// dropdown item { name, id }
const FormDropdown = ({ 
    options, 
    selected_option_id, 
    onSelect,
    placeholder = 'Select Option',
    disabled,
    dropdownMenuRef,
    ...props
}) => {
    const selected = selected_option_id
        ? options.find(option => option.id.toString() === selected_option_id.toString())?.name
        : placeholder;
    const [isActive, setIsActive ] = useState(false);

    return (
        <Dropdown 
            onSelect={(e) => disabled ? null : onSelect(e)} 
            className={`'w-100 text-left form-dropdown rounded' ${isActive ? 'active' : ''}`}
            onToggle={(isOpen) => disabled ? null : setIsActive(isOpen)}
            disabled={disabled}
            style={props?.style}
        >
            <Dropdown.Toggle variant="transparent" className="w-100 text-left text-truncate">
                {selected}
                <Image 
                    src={DropdownIcon} 
                    height="8" 
                    width="8" 
                    className="dropdown-icon"
                />
            </Dropdown.Toggle>
            <Dropdown.Menu 
                className="w-100"
                ref={dropdownMenuRef}
                style={props?.menuStyle ? props.menuStyle : { maxHeight: 300, overflowY: 'auto' }}
            >
                {options.map((option) => (
                    <Dropdown.Item
                        key={option.id}
                        active={option.id === selected_option_id}
                        eventKey={option.id}
                        className={'text-truncate d-flex justify-content-between'}
                    >
                        <div className='w-80 text-truncate'>
                            {option.name}
                        </div>
                        
                        { option.id === selected_option_id &&
                          <div className="dropdown-check h-100">
                            <img src={CheckIcon} alt="Selected" height={10}/>
                          </div>
                        }
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export { FormDropdown };